import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import type * as v from 'valibot';
import { COLORS_MAP } from '../../constants';
import type { StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
import { SPACING_MAP } from './constants';
import type { wellSCSchema } from './schema';
import type { SpacingValue } from './types';
export type WellProps = StructuredContentDocumentWithRenderer<v.InferInput<typeof wellSCSchema>>;
export const CSS_VARIABLES = {
  borderRadius: '--nw-sc-Well-borderRadius'
} as const;
export const Well = t0 => {
  const $ = _c(12);
  const {
    props
  } = t0;
  let children;
  let color;
  let t1;
  if ($[0] !== props) {
    const {
      children: t2,
      color: t3,
      ...spacingProps
    } = props;
    children = t2;
    color = t3;
    t1 = Object.entries(spacingProps).reduce(_temp, {});
    $[0] = props;
    $[1] = children;
    $[2] = color;
    $[3] = t1;
  } else {
    children = $[1];
    color = $[2];
    t1 = $[3];
  }
  const spacingMap = t1;
  const t2 = COLORS_MAP[color ?? "transparent"];
  let t3;
  if ($[4] !== spacingMap || $[5] !== t2) {
    t3 = {
      bgcolor: t2,
      ...spacingMap,
      borderRadius: `var(${CSS_VARIABLES.borderRadius}, 0)`
    };
    $[4] = spacingMap;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children) {
    t4 = renderStructuredContent(children);
    $[7] = children;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <Box sx={t3}>{t4}</Box>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
function _temp(acc, t0) {
  const [prop, value] = t0;
  if (value) {
    acc[prop] = SPACING_MAP[value];
  }
  return acc;
}